import { Icon } from '@iconify/react/dist/iconify.js';
import { FormControl, FormHelperText, FormLabel } from '@mui/material';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import TextField from '@mui/material/TextField';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import moment from 'moment';
import Helpers from '../../helpers/helpers';
import "./datepicker.css";


export default function CustomizedDatePicker({ values, setFormValues, error, title, isOptional, name, disabled, InputProps, format, noFormated = false, minDate, placeholder = 'dd/mm/yyyy', sx }) {
    const outerTheme = createTheme({

    });
    const handleDateChange = (e) => {
        const date = e;
        const momentDate = moment(date, 'ddd MMM DD YYYY hh:mm:ss [GMT]ZZ (zz)');
        const isoString = momentDate.format('YYYY-MM-DD');
        if (Helpers.isNullOrEmpty(name)) {
            setFormValues(noFormated ? momentDate : isoString)
        } else {
            setFormValues((prevValues) => ({
                ...prevValues,
                [name]: isoString
            }))
        }

    }

    const defaultStyle = {
        backgroundColor: disabled ? '#F1F3F4' : "",
        color: disabled ? '#52525280' : "",
        border: '1.5px solid #E9E9E9',
        borderRadius: 3,
        padding: "7px",
        paddingInline: 2,
        marginTop: '4px',
    };

    return (
        <>
            <FormControl variant="outlined" fullWidth>
                {title && <FormLabel style={{ fontFamily: 'SophiaPro', fontWeight: 500, fontSize: 14, margin: 0, color: "#594A4E", justifyContent: "space-between", display: "flex" }}>{title} {isOptional ? <span className="optional-label">Optional</span> : null}</FormLabel>}
                <ThemeProvider theme={outerTheme}>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                            error={error ? true : false}
                            value={values === '' ? null : values}
                            hiddenLabel={true}
                            disabled={disabled}
                            InputProps={{ ...InputProps, }}
                            format={format ? format : 'dd/MM/yyyy'}
                            minDate={minDate}
                            slotProps={{
                                textField: {
                                    variant: "standard",
                                    placeholder: 'dd/mm/yyyy',
                                    InputProps: {
                                        disableUnderline: true,
                                    },
                                    // inline style on the native input to override generated MUI class padding
                                    inputProps: {
                                        style: { paddingBlock: '3px', fontSize: 14 }
                                    }
                                },
                            }}
                            slots={{
                                openPickerIcon: () =>
                                    <div className='d-flex align-items-center justify-content-center'>
                                        <Icon icon="mdi:calendar-blank-outline" className="font-size-16" style={{ color: '#BDBDBD' }} />
                                    </div>
                            }}
                            onChange={(e) => handleDateChange(e)}
                            sx={{
                                ...sx,
                                ...defaultStyle
                            }}
                            control={(params) => <TextField size="small" {...params} />}
                        />
                    </LocalizationProvider></ThemeProvider>
            </FormControl>
            {error && <FormHelperText sx={{ color: "#BA2727" }}><Icon icon={'fluent:error-circle-24-filled'} height={16} width={16} />{error || ""}</FormHelperText>}
        </>


    );
}
